import * as actionTypes from './actionTypes';

export const fetchFolderTree = spaceId => ({
  type: actionTypes.FETCH_FOLDER_TREE,
  spaceId,
});
export const fetchFolderTreeSuccess = (ids, spaceId, folderTree) => ({
  type: actionTypes.FETCH_FOLDER_TREE_SUCCESS,
  ids,
  spaceId,
  folderTree,
});

export const fetchChildren = (spaceId, parentId = null) => ({
  type: actionTypes.FETCH_CHILDREN,
  spaceId,
  parentId,
});
export const fetchChildrenSuccess = ids => ({
  type: actionTypes.FETCH_CHILDREN_SUCCESS,
  ids,
});

export const fetchFolderDocumentCountBySpaceId = spaceId => ({
  type: actionTypes.FETCH_FOLDER_DOCUMENT_COUNT,
  spaceId,
});
export const fetchFolderDocumentCountBySpaceIdSuccess = documentCountByFolderId => ({
  type: actionTypes.FETCH_FOLDER_DOCUMENT_COUNT_SUCCESS,
  documentCountByFolderId,
});

export const createFolder = folder => ({
  type: actionTypes.CREATE,
  folder,
});
export const createFolderSuccess = id => ({
  type: actionTypes.CREATE_SUCCESS,
  id,
});

export const createMultipleFolders = multipleFolders => ({
  type: actionTypes.CREATE_MULTIPLE,
  multipleFolders,
});
export const createMultipleFoldersSuccess = ids => ({
  type: actionTypes.CREATE_MULTIPLE_SUCCESS,
  ids,
});

export const updateFolder = (folder, fetchFolderTreeAfterUpdate = true) => ({
  type: actionTypes.UPDATE,
  folder,
  fetchFolderTreeAfterUpdate,
});
export const updateFolderSuccess = id => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const updateMultipleFolders = folders => ({
  type: actionTypes.UPDATE_MULTIPLE,
  folders,
});
export const updateMultipleFoldersSuccess = ids => ({
  type: actionTypes.UPDATE_MULTIPLE_SUCCESS,
  ids,
});

export const deleteFolder = folder => ({
  type: actionTypes.DELETE,
  folder,
});
export const deleteFolderSuccess = id => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});
export const deleteFolderError = error => ({
  type: actionTypes.DELETE_ERROR,
  error,
});

export const setActiveFolderId = id => ({
  type: actionTypes.SET_ACTIVE_FOLDER_ID,
  id,
});

export const setEditingFolderId = id => ({
  type: actionTypes.SET_EDITING_FOLDER_ID,
  id,
});

export const setActiveFolderTree = folderTree => ({
  type: actionTypes.SET_ACTIVE_FOLDER_TREE,
  folderTree,
});

export const setFolderTree = (spaceId, folderTree) => ({
  type: actionTypes.SET_FOLDER_TREE,
  spaceId,
  folderTree,
});

export const navigateToFolder = folder => ({
  type: actionTypes.NAVIGATE_TO_FOLDER,
  folder,
});
